import { render, staticRenderFns } from "./ContentContributorsBlock.vue?vue&type=template&id=2c83b637&scoped=true"
import script from "./ContentContributorsBlock.vue?vue&type=script&lang=js"
export * from "./ContentContributorsBlock.vue?vue&type=script&lang=js"
import style0 from "./ContentContributorsBlock.vue?vue&type=style&index=0&id=2c83b637&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c83b637",
  null
  
)

export default component.exports